import './App.css';
import React, { useEffect } from "react";
import { MsalProvider,  useMsal } from "@azure/msal-react";
import { b2cPolicies } from './authConfig';
import { EventType, InteractionType } from "@azure/msal-browser";
import Protected from './Components/Protected';
import TagManager from 'react-gtm-module';

// Setting up and initializing Google Tag Manager.
const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GTM,
    dataLayer: {}
}

TagManager.initialize(tagManagerArgs)

// Container for the protected content.
const Page = () => {
  const { instance } = useMsal();
  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      if (event.eventType === EventType.LOGIN_FAILURE) {
        if (event.error && event.error.errorMessage.indexOf("AADB2C90118") > -1) {
          if (event.interactionType === InteractionType.Redirect) {
            instance.loginRedirect(b2cPolicies.authorities.forgotPassword);
          }
        }
      } else if (event.eventType === EventType.LOGIN_SUCCESS) {
        if (event.payload.idTokenClaims["acr"] === "b2c_1_reset") {
          // Tokens returned from password reset policy cannot be used for sign-in policy, must log out then sign back in
          instance.logout({
            account: event.payload.account
          });
        }
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
  }, [instance]);

  return <Protected />
};

// Relying on msal library to protect pages and ask for autorized users.
const App = ({ instance }) => {
  return (
    <div className="App" id="FclCDP">
      <MsalProvider instance={instance}>
        <Page />
      </MsalProvider>
    </div>
  );
}

export default App;
